const translations = {
  NL: {
    nav: {
      home: "Home",
      about: "Over Ons",
      services: "Diensten",
      pricing: "Prijzen",
      download: "Download App",
      contact: "Contact",
      cta: "Download App"
    },
    hero: {
      title: "Huur een bestelwagen,",
      titleHighlight: "wanneer je wilt.",
      subtitle: "RentComing maakt het huren van een bestelwagen eenvoudig en snel. Download de app en boek direct jouw bestelwagen voor verhuizingen, leveringen of transport.",
      downloadBtn: "Download de App",
      learnMore: "Meer informatie"
    },
    about: {
      tag: "Over Ons",
      title: "Betrouwbaar transport binnen handbereik",
      description: "RentComing is de slimste manier om een bestelwagen te huren. Of je nu verhuist, grote aankopen transporteert of leveringen regelt — met onze app heb je binnen enkele minuten een bestelwagen geboekt. Eenvoudig, snel en betrouwbaar.",
      stat1Label: "Tevreden klanten",
      stat3Label: "Stad"
    },
    services: {
      tag: "Onze Diensten",
      title: "Alles wat je nodig hebt",
      items: [
        {
          title: "Bestelwagen Verhuur",
          description: "Twee voordelige tarieven: €50 voor huren tot 6 uur en een dagtarief vanaf €69 vanaf 6 uur. Hoe langer je huurt, hoe meer korting — tot wel 40%."
        },
        {
          title: "Verhuisservice",
          description: "Plan je verhuizing via de app. Kies je bestelwagen en rijd zelf of laat ons rijden."
        },
        {
          title: "Zakelijk Transport",
          description: "Zakelijke leveringen en transport. Betrouwbaar en op tijd, elke keer."
        },
        {
          title: "24/7 Beschikbaar",
          description: "Boek op elk moment van de dag. Onze bestelwagens staan altijd voor je klaar."
        },
        {
          title: "Verzekerd Rijden",
          description: "Alle voertuigen zijn volledig verzekerd. Rij zonder zorgen."
        },
        {
          title: "Snelle Boeking",
          description: "In slechts 3 stappen geboekt via de app. Geen gedoe, geen wachttijden."
        }
      ]
    },
    pricing: {
      tag: "Prijzen",
      title: "Transparante tarieven",
      subtitle: "Geen verrassingen. Twee eenvoudige tarieven — en hoe langer je huurt, hoe meer korting je krijgt.",
      cards: [
        {
          label: "Korte huur",
          duration: "Tot 6 uur",
          prefix: "",
          price: "€50",
          unit: "",
          description: "Ideaal voor korte ritten, het ophalen van meubels of snelle leveringen."
        },
        {
          label: "Dagtarief",
          duration: "Vanaf 6 uur",
          prefix: "vanaf",
          price: "€69",
          unit: "/ dag",
          description: "Huur je langer dan 6 uur? Dan geldt automatisch het voordelige dagtarief."
        }
      ],
      popular: "Meest gekozen",
      discountTitle: "Langer huren = meer korting",
      discounts: [
        { days: "3+ dagen", off: "10%" },
        { days: "6+ dagen", off: "15%" },
        { days: "15+ dagen", off: "20%" },
        { days: "20+ dagen", off: "30%" },
        { days: "31+ dagen", off: "40%" }
      ],
      discountLabel: "korting",
      note: "Alle prijzen zijn inclusief btw. Boek eenvoudig via de app."
    },
    downloadApp: {
      tag: "Download",
      title: "Download de RentComing App",
      subtitle: "Boek jouw bestelwagen direct via onze app. Beschikbaar voor iOS en Android.",
      googlePlay: "Google Play",
      appStore: "App Store"
    },
    contact: {
      tag: "Contact",
      title: "Neem contact op",
      subtitle: "Heb je vragen? Stuur ons een bericht en we reageren zo snel mogelijk.",
      namePlaceholder: "Jouw naam",
      emailPlaceholder: "Jouw e-mailadres",
      phonePlaceholder: "Telefoonnummer (optioneel)",
      messagePlaceholder: "Jouw bericht",
      sendBtn: "Verstuur bericht",
      sending: "Verzenden...",
      successMsg: "Bericht succesvol verzonden!",
      errorMsg: "Er ging iets mis. Probeer opnieuw.",
      address: "Adres",
      email: "E-mail",
      phone: "Telefoon"
    },
    footer: {
      privacy: "Privacybeleid",
      terms: "Algemene Voorwaarden",
      rights: "Alle rechten voorbehouden."
    },
    privacy: {
      title: "Privacybeleid",
      lastUpdated: "Laatst bijgewerkt: december 2025",
      sections: [
        {
          title: "1. Inleiding",
          content: "Dit privacybeleid beschrijft hoe RentComing uw persoonlijke gegevens verzamelt, gebruikt en beschermt wanneer u onze app en website gebruikt."
        },
        {
          title: "2. Gegevens die we verzamelen",
          content: "Wij verzamelen de volgende gegevens: naam, e-mailadres, telefoonnummer, locatiegegevens (voor het vinden van bestelwagens in de buurt), betalingsgegevens en gebruiksgegevens van de app."
        },
        {
          title: "3. Gebruik van gegevens",
          content: "Uw gegevens worden gebruikt voor: het verwerken van boekingen, het verbeteren van onze diensten, communicatie over uw reserveringen, en het naleven van wettelijke verplichtingen."
        },
        {
          title: "4. Gegevensbescherming",
          content: "Wij nemen passende technische en organisatorische maatregelen om uw persoonlijke gegevens te beschermen tegen ongeautoriseerde toegang, verlies of misbruik."
        },
        {
          title: "5. Uw rechten",
          content: "U heeft het recht om uw gegevens in te zien, te corrigeren of te verwijderen. Neem contact op via info@rentcoming.com voor verzoeken."
        },
        {
          title: "6. Contact",
          content: "Voor vragen over dit privacybeleid kunt u contact opnemen via info@rentcoming.com."
        }
      ]
    },
    terms: {
      title: "Algemene Voorwaarden",
      lastUpdated: "Laatst bijgewerkt: december 2025",
      sections: [
        {
          title: "1. Definities",
          content: "\"RentComing\" verwijst naar het platform en de app voor bestelwagenverhuur. \"Gebruiker\" verwijst naar elke persoon die gebruik maakt van onze diensten."
        },
        {
          title: "2. Diensten",
          content: "RentComing biedt een platform voor het huren van bestelwagens. Alle boekingen worden verwerkt via de RentComing app."
        },
        {
          title: "3. Boekingen",
          content: "Een boeking is definitief na bevestiging via de app. Annuleringen dienen minimaal 24 uur van tevoren te worden doorgegeven."
        },
        {
          title: "4. Betalingen",
          content: "Alle betalingen worden veilig verwerkt via de app. Er gelden twee tarieven: €50 voor huurperiodes tot 6 uur en een dagtarief vanaf €69 voor huurperiodes vanaf 6 uur. Bij langere huurperiodes gelden kortingen: 10% vanaf 3 dagen, 15% vanaf 6 dagen, 20% vanaf 15 dagen, 30% vanaf 20 dagen en 40% vanaf 31 dagen. Prijzen zijn inclusief btw tenzij anders vermeld."
        },
        {
          title: "5. Aansprakelijkheid",
          content: "De huurder is verantwoordelijk voor het voertuig tijdens de huurperiode. Schade dient direct te worden gemeld."
        },
        {
          title: "6. Toepasselijk recht",
          content: "Op deze voorwaarden is het Belgisch recht van toepassing."
        }
      ]
    }
  },
  FR: {
    nav: {
      home: "Accueil",
      about: "À Propos",
      services: "Services",
      pricing: "Tarifs",
      download: "Télécharger",
      contact: "Contact",
      cta: "Télécharger l'App"
    },
    hero: {
      title: "Louez une camionnette,",
      titleHighlight: "quand vous voulez.",
      subtitle: "RentComing rend la location de camionnettes simple et rapide. Téléchargez l'application et réservez directement votre camionnette pour déménagements, livraisons ou transports.",
      downloadBtn: "Télécharger l'App",
      learnMore: "En savoir plus"
    },
    about: {
      tag: "À Propos",
      title: "Transport fiable à portée de main",
      description: "RentComing est le moyen le plus intelligent de louer une camionnette. Que vous déménagiez, transportiez des achats importants ou organisiez des livraisons — avec notre application, vous réservez une camionnette en quelques minutes. Simple, rapide et fiable.",
      stat1Label: "Clients satisfaits",
      stat3Label: "Ville"
    },
    services: {
      tag: "Nos Services",
      title: "Tout ce dont vous avez besoin",
      items: [
        {
          title: "Location de Camionnettes",
          description: "Deux tarifs avantageux : 50 € pour les locations de moins de 6 heures et un tarif journalier à partir de 69 € dès 6 heures. Plus vous louez longtemps, plus la remise est importante — jusqu'à 40 %."
        },
        {
          title: "Service de Déménagement",
          description: "Planifiez votre déménagement via l'app. Choisissez votre camionnette et conduisez vous-même."
        },
        {
          title: "Transport Professionnel",
          description: "Livraisons et transports professionnels. Fiable et ponctuel, à chaque fois."
        },
        {
          title: "Disponible 24/7",
          description: "Réservez à tout moment. Nos camionnettes sont toujours prêtes pour vous."
        },
        {
          title: "Conduite Assurée",
          description: "Tous les véhicules sont entièrement assurés. Conduisez sans souci."
        },
        {
          title: "Réservation Rapide",
          description: "Réservé en seulement 3 étapes via l'app. Sans tracas, sans attente."
        }
      ]
    },
    pricing: {
      tag: "Tarifs",
      title: "Des tarifs transparents",
      subtitle: "Pas de surprises. Deux tarifs simples — et plus vous louez longtemps, plus la remise est importante.",
      cards: [
        {
          label: "Location courte",
          duration: "Moins de 6 heures",
          prefix: "",
          price: "50 €",
          unit: "",
          description: "Idéal pour les trajets courts, récupérer des meubles ou les livraisons rapides."
        },
        {
          label: "Tarif journalier",
          duration: "À partir de 6 heures",
          prefix: "à partir de",
          price: "69 €",
          unit: "/ jour",
          description: "Vous louez plus de 6 heures ? Le tarif journalier avantageux s'applique automatiquement."
        }
      ],
      popular: "Le plus choisi",
      discountTitle: "Louer plus longtemps = plus de remise",
      discounts: [
        { days: "3+ jours", off: "10%" },
        { days: "6+ jours", off: "15%" },
        { days: "15+ jours", off: "20%" },
        { days: "20+ jours", off: "30%" },
        { days: "31+ jours", off: "40%" }
      ],
      discountLabel: "de remise",
      note: "Tous les prix incluent la TVA. Réservez facilement via l'application."
    },
    downloadApp: {
      tag: "Télécharger",
      title: "Téléchargez l'App RentComing",
      subtitle: "Réservez votre camionnette directement via notre application. Disponible pour iOS et Android.",
      googlePlay: "Google Play",
      appStore: "App Store"
    },
    contact: {
      tag: "Contact",
      title: "Contactez-nous",
      subtitle: "Vous avez des questions ? Envoyez-nous un message et nous répondrons dès que possible.",
      namePlaceholder: "Votre nom",
      emailPlaceholder: "Votre adresse e-mail",
      phonePlaceholder: "Numéro de téléphone (optionnel)",
      messagePlaceholder: "Votre message",
      sendBtn: "Envoyer le message",
      sending: "Envoi en cours...",
      successMsg: "Message envoyé avec succès !",
      errorMsg: "Une erreur s'est produite. Veuillez réessayer.",
      address: "Adresse",
      email: "E-mail",
      phone: "Téléphone"
    },
    footer: {
      privacy: "Politique de Confidentialité",
      terms: "Conditions Générales",
      rights: "Tous droits réservés."
    },
    privacy: {
      title: "Politique de Confidentialité",
      lastUpdated: "Dernière mise à jour : décembre 2025",
      sections: [
        {
          title: "1. Introduction",
          content: "Cette politique de confidentialité décrit comment RentComing collecte, utilise et protège vos données personnelles lorsque vous utilisez notre application et notre site web."
        },
        {
          title: "2. Données collectées",
          content: "Nous collectons les données suivantes : nom, adresse e-mail, numéro de téléphone, données de localisation, informations de paiement et données d'utilisation de l'application."
        },
        {
          title: "3. Utilisation des données",
          content: "Vos données sont utilisées pour : le traitement des réservations, l'amélioration de nos services, la communication concernant vos réservations et le respect des obligations légales."
        },
        {
          title: "4. Protection des données",
          content: "Nous prenons les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, perte ou abus."
        },
        {
          title: "5. Vos droits",
          content: "Vous avez le droit de consulter, corriger ou supprimer vos données. Contactez-nous à info@rentcoming.com pour toute demande."
        },
        {
          title: "6. Contact",
          content: "Pour toute question concernant cette politique de confidentialité, contactez-nous à info@rentcoming.com."
        }
      ]
    },
    terms: {
      title: "Conditions Générales",
      lastUpdated: "Dernière mise à jour : décembre 2025",
      sections: [
        {
          title: "1. Définitions",
          content: "\"RentComing\" désigne la plateforme et l'application de location de camionnettes. \"Utilisateur\" désigne toute personne utilisant nos services."
        },
        {
          title: "2. Services",
          content: "RentComing offre une plateforme pour la location de camionnettes. Toutes les réservations sont traitées via l'application RentComing."
        },
        {
          title: "3. Réservations",
          content: "Une réservation est définitive après confirmation via l'application. Les annulations doivent être communiquées au moins 24 heures à l'avance."
        },
        {
          title: "4. Paiements",
          content: "Tous les paiements sont traités de manière sécurisée via l'application. Deux tarifs s'appliquent : 50 € pour les locations de moins de 6 heures et un tarif journalier à partir de 69 € pour les locations à partir de 6 heures. Des remises s'appliquent aux locations plus longues : 10% à partir de 3 jours, 15% à partir de 6 jours, 20% à partir de 15 jours, 30% à partir de 20 jours et 40% à partir de 31 jours. Les prix incluent la TVA sauf indication contraire."
        },
        {
          title: "5. Responsabilité",
          content: "Le locataire est responsable du véhicule pendant la période de location. Tout dommage doit être signalé immédiatement."
        },
        {
          title: "6. Droit applicable",
          content: "Ces conditions sont soumises au droit belge."
        }
      ]
    }
  },
  EN: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      download: "Download App",
      contact: "Contact",
      cta: "Download App"
    },
    hero: {
      title: "Rent a van,",
      titleHighlight: "whenever you want.",
      subtitle: "RentComing makes renting a van simple and fast. Download the app and book your van directly for moves, deliveries, or transport.",
      downloadBtn: "Download the App",
      learnMore: "Learn more"
    },
    about: {
      tag: "About Us",
      title: "Reliable transport at your fingertips",
      description: "RentComing is the smartest way to rent a van. Whether you're moving, transporting large purchases, or arranging deliveries — with our app you'll have a van booked in minutes. Simple, fast, and reliable.",
      stat1Label: "Happy customers",
      stat3Label: "City"
    },
    services: {
      tag: "Our Services",
      title: "Everything you need",
      items: [
        {
          title: "Van Rental",
          description: "Two simple rates: €50 for rentals under 6 hours and a day rate from €69 for 6 hours or more. The longer you rent, the bigger your discount — up to 40%."
        },
        {
          title: "Moving Service",
          description: "Plan your move via the app. Choose your van and drive yourself or let us drive."
        },
        {
          title: "Business Transport",
          description: "Business deliveries and transport. Reliable and on time, every time."
        },
        {
          title: "Available 24/7",
          description: "Book at any time of day. Our vans are always ready for you."
        },
        {
          title: "Insured Driving",
          description: "All vehicles are fully insured. Drive without worry."
        },
        {
          title: "Quick Booking",
          description: "Booked in just 3 steps via the app. No hassle, no waiting."
        }
      ]
    },
    pricing: {
      tag: "Pricing",
      title: "Transparent rates",
      subtitle: "No surprises. Two simple rates — and the longer you rent, the bigger your discount.",
      cards: [
        {
          label: "Short rental",
          duration: "Up to 6 hours",
          prefix: "",
          price: "€50",
          unit: "",
          description: "Ideal for short trips, picking up furniture or quick deliveries."
        },
        {
          label: "Day rate",
          duration: "From 6 hours",
          prefix: "from",
          price: "€69",
          unit: "/ day",
          description: "Renting for more than 6 hours? The advantageous day rate applies automatically."
        }
      ],
      popular: "Most popular",
      discountTitle: "Rent longer = bigger discount",
      discounts: [
        { days: "3+ days", off: "10%" },
        { days: "6+ days", off: "15%" },
        { days: "15+ days", off: "20%" },
        { days: "20+ days", off: "30%" },
        { days: "31+ days", off: "40%" }
      ],
      discountLabel: "discount",
      note: "All prices include VAT. Book easily via the app."
    },
    downloadApp: {
      tag: "Download",
      title: "Download the RentComing App",
      subtitle: "Book your van directly via our app. Available for iOS and Android.",
      googlePlay: "Google Play",
      appStore: "App Store"
    },
    contact: {
      tag: "Contact",
      title: "Get in touch",
      subtitle: "Have questions? Send us a message and we'll respond as soon as possible.",
      namePlaceholder: "Your name",
      emailPlaceholder: "Your email address",
      phonePlaceholder: "Phone number (optional)",
      messagePlaceholder: "Your message",
      sendBtn: "Send message",
      sending: "Sending...",
      successMsg: "Message sent successfully!",
      errorMsg: "Something went wrong. Please try again.",
      address: "Address",
      email: "Email",
      phone: "Phone"
    },
    footer: {
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      rights: "All rights reserved."
    },
    privacy: {
      title: "Privacy Policy",
      lastUpdated: "Last updated: December 2025",
      sections: [
        {
          title: "1. Introduction",
          content: "This privacy policy describes how RentComing collects, uses, and protects your personal data when you use our app and website."
        },
        {
          title: "2. Data We Collect",
          content: "We collect the following data: name, email address, phone number, location data (for finding nearby vans), payment information, and app usage data."
        },
        {
          title: "3. Use of Data",
          content: "Your data is used for: processing bookings, improving our services, communicating about your reservations, and complying with legal obligations."
        },
        {
          title: "4. Data Protection",
          content: "We take appropriate technical and organizational measures to protect your personal data against unauthorized access, loss, or misuse."
        },
        {
          title: "5. Your Rights",
          content: "You have the right to view, correct, or delete your data. Contact us at info@rentcoming.com for requests."
        },
        {
          title: "6. Contact",
          content: "For questions about this privacy policy, contact us at info@rentcoming.com."
        }
      ]
    },
    terms: {
      title: "Terms & Conditions",
      lastUpdated: "Last updated: December 2025",
      sections: [
        {
          title: "1. Definitions",
          content: "\"RentComing\" refers to the platform and app for van rental. \"User\" refers to any person using our services."
        },
        {
          title: "2. Services",
          content: "RentComing offers a platform for renting vans. All bookings are processed via the RentComing app."
        },
        {
          title: "3. Bookings",
          content: "A booking is final after confirmation via the app. Cancellations must be communicated at least 24 hours in advance."
        },
        {
          title: "4. Payments",
          content: "All payments are processed securely via the app. Two rates apply: €50 for rentals under 6 hours and a day rate from €69 for rentals of 6 hours or more. Discounts apply to longer rentals: 10% from 3 days, 15% from 6 days, 20% from 15 days, 30% from 20 days and 40% from 31 days. Prices include VAT unless otherwise stated."
        },
        {
          title: "5. Liability",
          content: "The renter is responsible for the vehicle during the rental period. Damage must be reported immediately."
        },
        {
          title: "6. Applicable Law",
          content: "These terms are governed by Belgian law."
        }
      ]
    }
  }
};

export default translations;
